export const SUGGESTION_INSIGHTS = [
  {
    team: "sales",
    integrationCategory: "social",
    insights: "Capture buying signals from social platforms and open source communities to identify engaged prospects. Our AI-powered platform enriches these social signals with Person360 profiles for contextual outbound messaging. Automate sales plays based on social engagement patterns to reach prospects at the right moment with relevant context.",
  },
  {
    team: "sales",
    integrationCategory: "gtm",
    insights: "Unify CRM, marketing automation, and sales engagement data with Person360 identity resolution to eliminate duplicates. Automate outbound plays triggered by behavioral signals across your GTM stack with AI-generated personalized messaging. Score prospects transparently using comprehensive signals from all your business tools for higher-quality pipeline.",
  },
  {
    team: "sales",
    integrationCategory: "product",
    insights: "Connect product usage data to identify expansion opportunities and churn risks in real-time. Our platform enriches product signals with person-level context to enable targeted outbound for upsells and renewals. Automate alerts when key accounts show usage patterns that indicate buying intent or at-risk behavior.",
  },
  {
    team: "sales",
    integrationCategory: "custom",
    insights: "Integrate your proprietary data sources into a unified customer intelligence platform for complete visibility. Our AI-powered research capabilities analyze custom signals alongside 50+ other data sources for comprehensive account context. Automate personalized outbound workflows based on unique signals specific to your business model.",
  },
  {
    team: "marketing",
    integrationCategory: "social",
    insights: "Capture social and community engagement signals to identify high-intent prospects before they enter your funnel. Our platform enriches social interactions with Person360 profiles to enable targeted multi-channel campaigns. Automate marketing workflows triggered by community participation patterns to nurture engaged audiences.",
  },
  {
    team: "marketing",
    integrationCategory: "gtm",
    insights: "Unify marketing automation, CRM, and analytics data to create comprehensive customer profiles with waterfall enrichment. Our AI-powered platform scores leads using multi-signal intelligence beyond basic intent data for higher conversion rates. Automate cross-channel campaigns based on behavioral signals across your entire GTM stack.",
  },
  {
    team: "marketing",
    integrationCategory: "product",
    insights: "Connect product usage and feature adoption data to marketing campaigns for lifecycle optimization. Our platform identifies expansion opportunities and activation patterns to inform targeted campaigns. Automate account-based marketing plays triggered by product engagement signals for higher conversion.",
  },
  {
    team: "marketing",
    integrationCategory: "custom",
    insights: "Integrate your unique data sources into a unified platform for comprehensive campaign targeting. Our AI capabilities analyze custom signals alongside 50+ integrations to identify your ideal customer patterns. Automate marketing workflows based on proprietary signals that matter most to your business.",
  },
  {
    team: "revops",
    integrationCategory: "social",
    insights: "Enrich social and community signals with Person360 identity resolution to create unified customer profiles. Our platform provides transparent scoring methodology using social engagement patterns for data-driven pipeline forecasting. Automate data quality workflows to maintain clean records as prospects engage across social channels.",
  },
  {
    team: "revops",
    integrationCategory: "gtm",
    insights: "Unify data across your entire GTM stack with superior ML identity resolution to eliminate duplicates and low match rates. Our platform provides 50+ enrichment attributes via waterfall from multiple sources for complete customer intelligence. Automate workflow orchestration across sales, marketing, and customer success based on comprehensive behavioral signals.",
  },
  {
    team: "revops",
    integrationCategory: "product",
    insights: "Connect product usage data to CRM and marketing systems for end-to-end visibility into customer lifecycle. Our platform enriches product signals with person-level attribution to measure true pipeline influence. Automate cross-functional workflows triggered by product engagement patterns to optimize revenue operations.",
  },
  {
    team: "revops",
    integrationCategory: "custom",
    insights: "Integrate proprietary data sources into a unified platform with identity resolution across all touchpoints. Our AI-powered enrichment capabilities standardize custom signals for consistent reporting and analysis. Automate data quality processes and cross-system workflows based on your unique business requirements.",
  },
  {
    team: "community",
    integrationCategory: "social",
    insights: "Capture engagement across social platforms, forums, and open source communities to identify your most active members. Our platform enriches community interactions with Person360 profiles to understand the full customer journey. Automate recognition programs and targeted outreach triggered by community contribution patterns.",
  },
  {
    team: "community",
    integrationCategory: "gtm",
    insights: "Connect community engagement to business outcomes by integrating with your CRM and marketing platforms. Our AI-powered platform identifies which community activities drive pipeline and expansion opportunities. Automate workflows to route high-value community members to sales and success teams at optimal moments.",
  },
  {
    team: "community",
    integrationCategory: "product",
    insights: "Unify community engagement with product usage data to identify power users and advocates. Our platform enriches community interactions with product adoption patterns for targeted enablement programs. Automate feedback loops between community insights and product teams to drive feature adoption.",
  },
  {
    team: "community",
    integrationCategory: "custom",
    insights: "Integrate your unique community platforms and data sources into a unified engagement intelligence system. Our AI capabilities analyze custom community signals alongside product and GTM data for holistic member understanding. Automate community workflows based on proprietary engagement patterns specific to your ecosystem.",
  },
]